import React, { Component } from 'react';
import Spinner from 'react-spinkit'

class Loading extends Component {
  render() {
        return (
                <Spinner
                    style={{position: "fixed", 
                            top:  'calc(50vh - 30px)', 
                            textAlign: 'center', 
                            flexDirection: 'row',
                            left: "0",
                            right: '0'
                            }}
                    className="loading photo-loader text-center"
                    name="ball-clip-rotate"
                    color="black"
                    fadeIn="none"
                    
                />
      
        )
    }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/PhotoJournal/Loading.js